import * as React from "react";
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.86,12.11v-.22l6.51-6.71,1.39,1.36L7.27,11H20.14v2H7.27l4.49,4.47-1.39,1.36Z" }));
export default SvgArrowLeft;
